import classNames from 'classnames';
import { FC } from 'react';

import { Status } from '../../Status/Status';
import { BaseCard } from '../model/BaseCard/BaseCard';
import { WeaponPartCardProps } from '../model/types';

import { Row, RowRenderer } from './RowRenderer';
import { statuses } from './WeaponRegisteredCard/constants';

export const WeaponPartCard: FC<WeaponPartCardProps> = ({ data, status, variant }) => {
  const rows: Row[] = [
    {
      label: 'Тип',
      value: data?.type,
      dataTestId: 'weapon-part-card-type',
    },
    {
      label: 'Cерійний номер',
      value: data?.serialNum,
      dataTestId: 'weapon-part-card-type',
    },
  ];

  return (
    <BaseCard
      className={classNames('service-row-card', `service-row-card--${variant}`)}
      header={
        <div className="service-row-card__status-wrapper">
          <Status key={status} status={statuses[status]} />
        </div>
      }
      body={
        <div className="service-row-card__meta-wrapper">
          <RowRenderer rows={rows} />
        </div>
      }
    />
  );
};
